import React, { useRef } from 'react'
import { useWindowDimensions } from 'react-native'
// eslint-disable-next-line no-restricted-imports -- this is a valid import for web styled-components
import styledWeb from 'styled-components'
import styled, { useTheme } from 'styled-components/native'

const SMALL_SCREEN_WIDTH = 350

type Props = {
  onLoad: () => void
  uri: string
  bordered?: boolean
}

const StyledContainer = styled.View<{
  bordered?: boolean
}>`
  flex: 1;
  overflow: hidden;
  ${({ bordered, theme }) =>
    bordered &&
    `
  border-width: 1px;
  border-color: ${theme.colors.elementsBorder};
  border-style: solid;
  border-radius: ${theme.metrics.borderRadius.small}px;
  `}
`

const StyledIframe = styledWeb.iframe<{ isSmallScreen: boolean }>`
  border-width: 0;
  padding: ${({ theme, isSmallScreen }) =>
    theme.metrics.baseMargin * (isSmallScreen ? 0.5 : 1.25)}px;
  height: 100%;
`

// FYI, in order for `injectedJavaScript` to work on web (iframe), additional work will be needed. Bye dark mode, for now.
const WebContentView = ({ onLoad, uri, bordered }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const theme = useTheme()
  const { width } = useWindowDimensions()
  const isSmallScreen = width < SMALL_SCREEN_WIDTH

  return (
    <StyledContainer bordered={bordered} testID="WEB_CONTENT_VIEW">
      <StyledIframe
        ref={iframeRef}
        src={uri}
        onLoad={() => onLoad?.()}
        allow="fullscreen"
        theme={theme}
        isSmallScreen={isSmallScreen}
      />
    </StyledContainer>
  )
}

export default WebContentView
